<template>
    <div>              
       <div class="step-content">
        <div class="step-item">
            <div class="step-title">
                <h2 class="step-titlte-text">Step 01</h2>
                <p class="step-number">01</p>                
            </div>
            <div class="step-content">
                <p class="step-content-text">
                    You can follow the instructions to add the app directly to the Home screen from the current page
                </p>                
            </div>
        </div>
        <div class="step-item">
            <div class="step-title">
                <h2 class="step-titlte-text">Step 02</h2>
                <p class="step-number">02</p>                
            </div>
            <div class="step-content">
                <p class="step-content-text">
                    Tap The Share lcon
                </p>
                <div class="step-content-img">
                    <img src="../../../src/assets/images/download/edge2.png" alt="">
                </div>
            </div>
        </div>
        <div class="step-item">
            <div class="step-title">
                <h2 class="step-titlte-text">Step 03</h2>
                <p class="step-number"> 03</p>                
            </div>
            <div class="step-content">
                <p class="step-content-text">Tap "Add to Home Screen"</p>
                <div class="step-content-img">
                    <img src="../../../src/assets/images/download/edge3.png" alt="">
                </div>
            </div>
        </div>
        <div class="step-item">
            <div class="step-title">
                <h2 class="step-titlte-text">Step 04</h2>
                <p class="step-number">04</p>                
            </div>
            <div class="step-content">
                <p class="step-content-text">Tap "Add"</p>
                <div class="step-content-img">
                    <img src="../../../src/assets/images/download/safari3.png" alt="">
                </div>
            </div>
        </div>
        <div class="step-item">
            <div class="step-title">
                <h2 class="step-titlte-text">Step 05</h2>
                <p class="step-number">05</p>                
            </div>
            <div class="step-content">
                <p class="step-content-text">Tap "Add"</p>
                <div class="step-content-img">
                    <img src="../../../src/assets/images/addtohome.jpg" alt="">
                </div>
            </div>
        </div>
       </div>
    </div>
</template>
<script>
import { onMounted } from 'vue';
export default {
    setup () {
        onMounted(()=>{
            document.body.style.background = "#eee8fd"
        })
    }
}
</script>
<style lang="less">
div.video-guide {
  padding:30px;
  h2.vide-title {
    font-size: 34px;
    font-weight: 700;    
  }
  div.video-content {
    padding:30px 0;
    video {
      
    }
  }
}

div.step-content {
  padding:30px;
  div.step-item {
    margin-bottom: 20px;
    div.step-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h2.step-titlte-text {
        color:#fff;
        font-size: 30px;
        padding:20px 30px;
        border-radius: 40px 40px 0 0;
        background:#8e62f4;
        width:300px;
      }

      p.step-number {
        color:#8e62f4;
        font-size: 40px;
      }
    }

    div.step-content {
      padding:30px;
      border-radius: 0 0 50px 50px;
      background:#fff;
      position:relative;
      top:-10px;
      p.step-content-text {
        color:#333;
        font-size: 28px;
        line-height: 1.5;
        word-break: break-all;
        margin-bottom: 30px;
      }
      .step-content-img{
        width:100%;        
        img{
          width: 100%;
          height:100%;
        }
      }
    }
  }
}</style>